import { Box } from '@/components';
import type { LedgerSsInspectionEvaluationSectionProps } from '@/features/mold/models/ledger';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentItem } from './ContentItem';
import { Section } from './Section';

export const SsInspectionEvaluationSection: FC<
  LedgerSsInspectionEvaluationSectionProps
> = ({ project }) => {
  const { t } = useTranslation();

  return (
    <Section
      title={t('inspection-evaluation')}
      items={[
        {
          subtitle: t(
            'inspection-and-improvement-by-iaa-administrative-jurisdiction',
          ),
          item: (
            <Box>
              <ContentItem
                label={t('inspection-result')}
                value={
                  project?.inspectionEvaluation
                    .inspectionAndImprovementByAdministrativeJurisdiction
                    ?.inspectionResult
                }
              />
              <ContentItem
                label={t('evaluation')}
                value={
                  project?.inspectionEvaluation
                    .inspectionAndImprovementByAdministrativeJurisdiction
                    ?.evaluation
                }
              />
              <ContentItem
                label={t('direction-of-improvement')}
                value={
                  project?.inspectionEvaluation
                    .inspectionAndImprovementByAdministrativeJurisdiction
                    ?.directionOfImprovement
                }
                isLast
              />
            </Box>
          ),
        },
      ]}
    />
  );
};
